module.exports = __webpack_public_path__ + "static/img/software21.63d16f1d.png";